import { useMemo } from "react";
import { PSelect, Select } from "./Select";

type TextOption = {
  id: number | string;
  label: string;
  required?: boolean;
};

type PTextDropdown<T extends TextOption> = {
  listOfValues: T[];
  value: PSelect["value"];
  onChange: PSelect["onChange"];
  label: string;
  color: string;
  baseColor: string;
  borderColor: string;
  titleColor?: string;
  expandedBorderColor?: string;
  onExpandedChange?: (expanded: boolean) => void;
  enableSearch?: boolean;
  description?: string;
  expanded?: boolean;
  required?: boolean;
  fontWeight?: string;
};

export const TextDropdown = <T extends TextOption>(props: PTextDropdown<T>) => {
  const {
    listOfValues,
    value,
    onExpandedChange,
    onChange,
    label,
    color = "text-base",
    baseColor,
    borderColor,
    titleColor = "text-text-base",
    expandedBorderColor,
    expanded,
    enableSearch = true,
    description,
    required = false,
    fontWeight = "font-normal",
  } = props;

  const options = useMemo(
    () =>
      listOfValues.map((item) => ({
        label: <span className="text-[12px]">{item.label}</span>,
        value: item.id,
      })),
    [listOfValues],
  );

  return (
    <div className="flex flex-col space-y-[4px]">
      <Select
        label={label}
        options={options}
        value={value}
        color={color}
        titleColor={titleColor}
        borderColor={borderColor}
        baseColor={baseColor}
        expandedBorderColor={expandedBorderColor}
        expanded={expanded}
        onExpandedChange={onExpandedChange}
        onChange={(val: any) => onChange?.(val)}
        required={required}
        getOptionCls={(isActive: boolean) =>
          isActive
            ? "text-text-navbar-active text-[12px]"
            : "text-text-base text-[12px]"
        }
        fontWeight={fontWeight}
        getSelectCls={() => "h-[38px]"}
        enableSearch={enableSearch}
        searchableLabels={listOfValues.map((item) => [item.label])}
      />

      {description && (
        <p className="text-text-subtle text-[10px] font-medium">
          {description}
        </p>
      )}
    </div>
  );
};
